import script from "./cardpriorityList.vue?vue&type=script&lang=ts&setup=true"
export * from "./cardpriorityList.vue?vue&type=script&lang=ts&setup=true"

import "./cardpriorityList.vue?vue&type=style&index=0&id=4d5697e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5697e3"]])

export default __exports__